import type { UserProps } from './types';

export const userContextValue: UserProps = {
  isAuthorized: false,
  isSubscribed: false,
  accessToken: '',
  key: '',
};

export const K_USER_KEY = 'x-api-key';

export const BEARER_REGEX = /^Bearer\s*/;
